module.exports = __webpack_public_path__ + "img/vasyr-2022.92a754a9.jpg";